import React, { Component } from 'react';
import DropZone from '../common/DropZone';

class ProjectDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            documents: {}
        }
    }

    componentDidMount() {
        if (this.props.documents) {
            this.setState({
                documents: this.props.documents
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.documents !== this.props.documents) {
            this.setState({ documents: this.props.documents })
        }
    }

    render() {
        const { onDeleteDocument, onDescriptionChange, onTagsChange, handleAddDocument, onTagsOpen } = this.props;
        const { documents } = this.state;
        return (
            <DropZone
                multiple={true}
                documents={documents}
                onTagsChange={onTagsChange}
                onTagsOpen={onTagsOpen}
                handleAddDocument={(accepted) => {
                    handleAddDocument(accepted)
                }}
                onDescriptionChange={onDescriptionChange}
                onDeleteDocument={onDeleteDocument}
            />
        );
    }
}

export default ProjectDocuments;


// WEBPACK FOOTER //
// ./src/components/ProjectSetup/ProjectDocuments.js